// CircleProgressBar.jsx
// Refs: https://github.com/zzarcon/react-circle/blob/master/src/circle.tsx

import React from 'react';
import PropTypes from 'prop-types';

const getCircleProgressOffset = value => {
  const radius = 175;
  const diameter = Math.round(Math.PI * radius * 2);
  return Math.round(((100 - Math.min(value, 100)) / 100) * diameter);
};

const CircleProgressBar = ({
  value,
  transition,
  barColor,
  barStrokeWidth,
  backgroundColor,
  BackgroundStrokeWidth,
  width,
  height,
}) => {
  const strokeDashoffset = getCircleProgressOffset(value);
  return (
    <svg width={width} height={height} viewBox="-25 -25 400 400">
      <circle
        stroke={backgroundColor}
        cx="175"
        cy="175"
        r="175"
        strokeWidth={BackgroundStrokeWidth}
        fill="none"
      />
      <circle
        stroke={barColor}
        transform="rotate(-90 175 175)"
        cx="175"
        cy="175"
        r="175"
        strokeDasharray="1100"
        strokeWidth={barStrokeWidth}
        strokeDashoffset="1100"
        strokeLinecap="round"
        fill="none"
        style={{
          strokeDashoffset,
          transition,
        }}
      />
    </svg>
  );
};

CircleProgressBar.propTypes = {
  value: PropTypes.number,
  barColor: PropTypes.string,
  barStrokeWidth: PropTypes.number,
  backgroundColor: PropTypes.string,
  BackgroundStrokeWidth: PropTypes.number,
  transition: PropTypes.string,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
};

CircleProgressBar.defaultProps = {
  value: 0,
  barStrokeWidth: 10,
  BackgroundStrokeWidth: 10,
  barColor: 'rgb(255,255,255)',
  backgroundColor: 'rgba(255,255,255,0.3)',
  transition: 'stroke-dashoffset 0.2s ease-out',
};

export default CircleProgressBar;
